import { Button } from '@/shared/components/ui/button'

interface WizardActionsProps {
  isFirst: boolean
  isLast: boolean
  loading?: boolean
  /** Deshabilita el botón "Siguiente"/"Finalizar" del paso actual. */
  disableNext?: boolean
  submitLabel?: string
  onPrev: () => void
  onNext: () => void
  onCancel?: () => void
}

export function WizardActions({
  isFirst,
  isLast,
  loading,
  disableNext,
  submitLabel = 'Finalizar',
  onPrev,
  onNext,
  onCancel,
}: WizardActionsProps) {
  return (
    <div className="flex items-center justify-between gap-2 border-t border-line pt-4">
      <div>
        {onCancel && (
          <Button type="button" variant="ghost" onClick={onCancel} disabled={loading}>
            Cancelar
          </Button>
        )}
      </div>
      <div className="flex items-center gap-2">
        {!isFirst && (
          <Button type="button" variant="outline" onClick={onPrev} disabled={loading}>
            Atrás
          </Button>
        )}
        <Button
          type="button"
          variant="primary"
          onClick={onNext}
          disabled={loading || disableNext}
        >
          {isLast ? submitLabel : 'Siguiente'}
        </Button>
      </div>
    </div>
  )
}
